<template>
<transition name="slide-right" @after-leave="afterLeave">
  <keep-alive><router-view id="fuiContent" class="fui-content"></router-view></keep-alive>
</transition>
</template>

<script>
export default {
  name: "fuiContent",
  mounted(){
    const cnt = document.querySelector("#fuiContent")
    if (cnt) window.fuiContentWidth = cnt.offsetWidth
    if (window.fuiNeedInitHeight) window.fuiInitListPanelHeight()
    window.fuiNeedInitHeight = 0
  },
  methods: {
    afterLeave(){
      if (window.fuiNeedInitHeight) window.fuiInitListPanelHeight()
      window.fuiNeedInitHeight = 0
    }
  }
};
</script>